import ToolTip from "../../ToolTip/ToolTip";

export const CRO_RESCHEDULE_TABLE_HEAD = [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  { field: "lead_name", headerName: "Student Name", width: 200 },
  {
    field: "course_name",
    headerName: "Course Name",
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.course_name}
          content={params.row.course_name}
        />
      );
    },
  },
  { field: "subject_name", headerName: "Subject Name", width: 200 },
  { field: "lead_mob_no", headerName: "Phone Number", width: 200 },
  { field: "session_date", headerName: "Session Date", width: 200 },
  { field: "from_time", headerName: "From Time", width: 150 },
  { field: "to_time", headerName: "To Time", width: 150 },
  {
    field: "rescheduled_reason",
    headerName: "Rescheduled Reason",
    width: 200,
  },
  {
    field: "rescheduled_date",
    headerName: "Rescheduled Date",
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.rescheduled_date}
          content={params.row.rescheduled_date}
        />
      );
    },
  },
  {
    field: "rescheduled_from_time",
    headerName: "From Time",
    width: 200,
  },
  {
    field: "rescheduled_to_time",
    headerName: "To Time",
    width: 200,
  },
];
